 const BaseUrl = "https://servicesapi.meander.software/"
 export default BaseUrl